// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__DmNUD","list":"BalanceDue_list__3OdJj","listRow":"BalanceDue_listRow__2WOwZ","total":"BalanceDue_total__3sr5Y"};